import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import { useReactToPrint } from 'react-to-print';
import centerImage from '../../assets/infosys.svg';
import QRCode from 'qrcode';
import userImage from '../../assets/user.png';
import { fetchVisitorTypes, fetchMeetingVenues, insertAppointment, fetchGateDetails, fetchNationality, fetchBuildingsByGate } from '../../services/Api';

const Container = styled.div`
  padding: 32px;
`;

const Header = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
`;

const PageHeader = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
  margin: 0;
    color:#293495;

`;

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
`;

const Card = styled.div`
  width: 80%;
  max-width: 600px;
  background: #fff;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  opacity: 1;
  padding: 20px;
  margin-top: 20px;
`;

const CardHeader = styled.h2`
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
  font-family: 'Segoe UI', 'Semibold';
    color:#293495;

`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FormGroup = styled.div`
  margin-bottom: 25px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const ISDSelect = styled.select`
  width: 130px;
  background-color: transparent;
  height: 30px;
  font-size: 14px;
  border: none;
  outline: none;
  text-align: center;
  color: #000;
  cursor: pointer;
    border-bottom: 2px solid #293495;

`;

const Input = styled.input`
  padding: 5px;
  border: none;
  border-bottom: 2px solid #293495;
  font-family: 'Segoe UI', 'Semibold';
  text-align: center;
  width: 40%;
  outline: none;
  background-color: transparent;
  text-align:left;
`;

const ErrorMessage = styled.p`
  color: red;
  font-size: 14px;
  margin-top: 5px;
  text-align: center;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  margin-top: 15px;
`;

const CheckboxLabel = styled.label`
  margin-left: 10px;
  font-family: 'Segoe UI', 'Semibold';
`;

const SubmitButton = styled.button`
  background: linear-gradient(#2B3497, #161A4C);
  box-shadow: 0px 10px 20px #2B349747;
  border: 1px solid #FFFFFF;
  border-radius: 7px;
  padding: 9px;
  color: white;
  font-family: 'Segoe UI', 'Semibold';
  cursor: pointer;
  width: 114px;
`;

const PopupContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const PopupContent = styled.div`
  position: relative;
  background: linear-gradient(#FFFFFF, #F5F5F5, #FFFFFF);
  box-shadow: 0px 0px 1px #0000004A;
  border-radius: 30px;
  padding: 30px;
  text-align: center;
  width: 500px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  cursor: pointer;
  margin-left: 10px;

  &.no-button {
    background-color: red; /* Change color to red for Close button */
  }
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;

const ReprintPassPage = () => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [baggageTag, setBaggageTag] = useState(false);
  const [error, setError] = useState('');
  const [showQRCode, setShowQRCode] = useState(false);
  const [qrCodeValue, setQrCodeValue] = useState('');
  const [cardData, setCardData] = useState('');
  const [profileImage, setProfileImage] = useState(null);
  const [nationalityList, setNationalityList] = useState('');
  const [defaultNationalityCode, setDefaultNationalityCode] = useState('');
  const handleIsdChange = (e) => {
    setMobileNumber('');
    const selectedNationality = nationalityList.find(
      (nation) => nation.nationalityCode === e.target.value
    );

    if (selectedNationality) {
      console.log("Selected Nationality Code:", selectedNationality.nationalityCode);
      setDefaultNationalityCode(selectedNationality.nationalityCode);
    }
  };

  useEffect(() => {
    const getNationality = async () => {
      try {
        const nation = await fetchNationality();
        setNationalityList(nation);
        const defaultNation = nation.find(item => item.isDefault);
        if (defaultNation) {
          setDefaultNationalityCode(defaultNation.nationalityCode);
        }
      } catch (error) {
        console.error('Error fetching meeting venues:', error);
      }
    };

    getNationality();
    // Reset form state or fetch from storage after page refresh
    setMobileNumber('');
    setCardData(null);
  }, []);

  const [reprintData, setReprintData] = useState();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validate the mobile number
    if (mobileNumber.trim() === "") {
      toast.error("Please enter the mobile number");
      return;
    }
    if (!defaultNationalityCode) {
      toast.error("Please select the nationality");
      return;
    }
    const formattedMobileNumber = `${defaultNationalityCode}-${mobileNumber}`;
    try {
      const response = await axios.get(`/VisitorDetails/ReprintPass/${formattedMobileNumber}`);
      console.log("response", response);
      if (response.data.statusCode == "-1") {
        if (response.data.statusMessage == "Nationality code does not match") {
          toast.error("Nationality code does not match")

          return
        }
        if (response.data.statusMessage == "Visitor not checked in") {
          toast.error("Visitor not checked in")
          setMobileNumber('');
          setBaggageTag(false);
          return
        } else if (response.data.statusMessage == "Visitor already left") {
          toast.error("Visitor already left")
          setMobileNumber('');
          setBaggageTag(false);
          return
        }
      }
      else {
        setReprintData(response.data.reprintPassDetails)
        console.log("reprintData", reprintData);
        if (baggageTag) {
          setShowQRCode(true);
          const encodedId = encodeCheckInId(reprintData[0].checkInId);
          console.log(encodedId);
          const formattedData = `${encodedId}`;
          setQrCodeValue(formattedData);
          setCardData(reprintData)
        } else {
          ReprintVisitorPass(reprintData)
        }
      }




      return
    } catch (error) {

    }

  }

  const handleSubmitSingleA = async (e) => {
    setError('');

    // Validate the mobile number
    if (mobileNumber.length !== 10) {
      setError('Mobile number must be exactly 10 digits.');
      return;
    }

    // Validate if the checkbox is checked
    // if () {
    //   setError('Please check the Baggage Tag checkbox.');
    //   return;
    // }

    // If validation passes, log the mobile number
    console.log('Mobile Number:', mobileNumber);

    try {
      const formattedMobileNumber = `${defaultNationalityCode}-${mobileNumber}`;

      const response = await axios.get(`/Appointment/Appointments/${formattedMobileNumber}`);
      console.log("response", response);
      if (response.status == 204) {
        toast.error('Visitor not checked in')
        return
      }
      if (response.data && response.data?.visitorName) {
        setCardData(response.data);
        setProfileImage(`data:image/png;base64,${response.data?.visitorPhoto}`);
        const formattedData = `${encryptMobileNumber(mobileNumber)}`;
        setQrCodeValue(formattedData);
        if (baggageTag) {
          setShowQRCode(true);
        }
        if (!baggageTag) {
          setShowQRCode(true);
          const formattedMobileNumber = `${defaultNationalityCode}-${mobileNumber}`;

          const responseV = await axios.get(`/Appointment/Appointments/${formattedMobileNumber}`);
          console.log("response", responseV);
          setProfileImage(`data:image/png;base64,${responseV.data?.visitorPhoto}`);

          // Create a new iframe element
          const iframe = document.createElement('iframe');
          iframe.style.position = 'absolute';
          iframe.style.width = '0';
          iframe.style.height = '0';
          iframe.style.border = 'none';
          document.body.appendChild(iframe);

          // Convert QR code to data URL
          const qrCodeDataUrl = qrCodeRef.current.toDataURL();

          // Fetch the SVG image and convert to base64
          const response = await fetch(centerImage);
          const blob = await response.blob();
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64Svg = reader.result;

            // Write the content into the iframe
            const doc = iframe.contentWindow.document;
            doc.open();

            doc.write(`
      <html>
            <head>
              <title>Print QR Code</title>
              <style>
                @page { 
                  margin: 0; 
                }
                body {
                  font-family: Arial, sans-serif;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 20px;
                  margin: 0;
                }
                .container {
                  width: 250px;
                  border: 1px solid #000;
                  padding: 10px;
                  text-align: center;
                }
                .header img {
                  width: 100px;
                  height: auto;
                  margin-bottom: 10px;
                }
                .imageN img {
                  width: 100px;
                  height: 100px;
                  margin-bottom: 10px;
                }
                .visitor-details {
                  text-align: left;
                  font-size: 14px;
                  margin-top: 10px;
                }
                .visitor-details p {
                  margin: 4px 0;
                  display: flex;
                }
                .label {
                  font-weight: 400;
                  width: 80px; /* Adjust width as needed to align labels and values */
                }
                .value {
                  flex-grow: 1;
                }
                .footer {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-top: 10px;
                  padding-top: 10px;
                }
                .footer div {
                  text-align: center;
                  font-weight: 600;
                  font-size: 12px;
                }
                .qr-code img {
                  width: 80px;
                  height: 80px;
                }
                /* Hide print and close buttons in print view */
                @media print {
                  .no-print { 
                    display: none; 
                  }
                }
              </style>
            </head>
            <body>
              <div class="container">
                <!-- Company Logo -->
                <div class="header">
                  <img src="${centerImage}" alt="Infosys Logo" />
                </div>
                
                <!-- Visitor Photo -->
                <div class="imageN">
                  <img src="${`data:image/png;base64,${responseV.data.visitorPhoto}`}" alt="Visitor Photo" />
                </div>

                <!-- Visitor Details -->
                <div class="visitor-details">
                  <p><span class="label">PassId:</span> <span class="value">${responseV.data?.id}</span></p>
                  <p><span class="label">Name:</span> <span class="value">${responseV.data?.visitorName || cardData?.visitorName}</span></p>
                  <p><span class="label">Org:</span> <span class="value">${responseV.data?.visitorCompany}</span></p>
                  <p><span class="label">Purpose:</span> <span class="value">${responseV.data?.purpose}</span></p>
                  <p><span class="label">Buildings:</span> <span class="value">${responseV.data?.building}</span></p>
                  <p><span class="label">Gates:</span> <span class="value">${responseV.data?.gate}</span></p>
                  <p><span class="label">IN-Time:</span> <span class="value">${new Date()?.toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).replace(/,/, '')}</span></p>
                  <p><span class="label">Assets:</span></p>
                  <p><span class="label">Remarks:</span></p>
                </div>

                <!-- Footer with QR Code and Signatures -->
                <div class="footer">
                  <div style="display:flex;flex-direction:column;text-align:left;">
                    <div style="margin-bottom:30px;text-align:left">Visitor Sign</div>
                    <div>Employee Sign</div>
                  </div>
                  <div class="qr-code">
                    <img src="${qrCodeDataUrl}" alt="QR Code" />
                  </div>
                </div>
              </div>
            </body>
          </html>
    `);
            doc.close();

            // Use onload event to ensure the content and styles are fully loaded before printing
            iframe.onload = () => {
              setTimeout(() => {
                iframe.contentWindow.print();
                document.body.removeChild(iframe); // Remove the iframe after printing
              }, 500);
              // Slight delay for style rendering
            };
          };
        }
      } else {
        setError('No data received or missing required fields.');
      }

    } catch (error) {
      console.error('Error fetching appointment details:', error);
      // Handle error scenarios
    }

    // Reset the form fields
    setMobileNumber('');
  };

  const handleSubmitSingleG = async (e) => {
    setError('');

    // Validate the mobile number
    if (mobileNumber.length !== 10) {
      setError('Mobile number must be exactly 10 digits.');
      return;
    }

    // Validate if the checkbox is checked
    // if () {
    //   setError('Please check the Baggage Tag checkbox.');
    //   return;
    // }

    // If validation passes, log the mobile number
    console.log('Mobile Number:', mobileNumber);

    try {

      const response = await axios.get(`/GroupCheckIn/GroupCheckIn/${mobileNumber}`);
      console.log("response", response);
      if (response.data && response.data?.visitorName) {
        setCardData(response.data);
        setProfileImage(`data:image/png;base64,${response.data?.visitorPhoto}`);
        const formattedData = `${encryptMobileNumber(mobileNumber)}`;
        setQrCodeValue(formattedData);
        if (baggageTag) {
          setShowQRCode(true);
        }
        if (!baggageTag) {
          setShowQRCode(true);
          const responseV = await axios.get(`/GroupCheckIn/GroupCheckIn/${mobileNumber}`);
          console.log("response", responseV);
          setProfileImage(`data:image/png;base64,${responseV.data?.visitorPhoto}`);

          // Create a new iframe element
          const iframe = document.createElement('iframe');
          iframe.style.position = 'absolute';
          iframe.style.width = '0';
          iframe.style.height = '0';
          iframe.style.border = 'none';
          document.body.appendChild(iframe);

          // Convert QR code to data URL
          const qrCodeDataUrl = qrCodeRef.current.toDataURL();

          // Fetch the SVG image and convert to base64
          const response = await fetch(centerImage);
          const blob = await response.blob();
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64Svg = reader.result;

            // Write the content into the iframe
            const doc = iframe.contentWindow.document;
            doc.open();

            doc.write(`
      <html>
            <head>
              <title>Print QR Code</title>
              <style>
                @page { 
                  margin: 0; 
                }
                body {
                  font-family: Arial, sans-serif;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 20px;
                  margin: 0;
                }
                .container {
                  width: 250px;
                  border: 1px solid #000;
                  padding: 10px;
                  text-align: center;
                }
                .header img {
                  width: 100px;
                  height: auto;
                  margin-bottom: 10px;
                }
                .imageN img {
                  width: 100px !important;
                  height: 100px !important;
                  margin-bottom: 10px;
                }
                .visitor-details {
                  text-align: left;
                  font-size: 14px;
                  margin-top: 10px;
                }
                .visitor-details p {
                  margin: 4px 0;
                  display: flex;
                }
                .label {
                  font-weight: 400;
                  width: 80px; /* Adjust width as needed to align labels and values */
                }
                .value {
                  flex-grow: 1;
                }
                .footer {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-top: 10px;
                  padding-top: 10px;
                }
                .footer div {
                  text-align: center;
                  font-weight: 600;
                  font-size: 12px;
                }
                .qr-code img {
                  width: 80px;
                  height: 80px;
                }
                /* Hide print and close buttons in print view */
                @media print {
                  .no-print { 
                    display: none; 
                  }
                }
              </style>
            </head>
            <body>
              <div class="container">
                <!-- Company Logo -->
                <div class="header">
                  <img src="${centerImage}" alt="Infosys Logo" />
                </div>
                
                <!-- Visitor Photo -->
                <div class="imageN">
                  <img src="${`data:image/png;base64,${responseV.data.visitorPhoto}`}" alt="Visitor Photo" />
                </div>

                <!-- Visitor Details -->
                <div class="visitor-details">
                  <p><span class="label">PassId:</span> <span class="value">${responseV.data?.checkInId}</span></p>
                  <p><span class="label">Name:</span> <span class="value">${responseV.data?.visitorName || cardData?.visitorName}</span></p>
                  <p><span class="label">Org:</span> <span class="value">${responseV.data?.visitorCompany}</span></p>
                  <p><span class="label">Purpose:</span> <span class="value">${responseV.data.purpose || ''}</span></p>
                  <p><span class="label">Buildings:</span> <span class="value">${responseV.data.buildings || ''}</span></p>
                  <p><span class="label">Gates:</span> <span class="value">${responseV.data.gates || ''}</span></p>
                  <p><span class="label">IN-Time:</span> <span class="value">${new Date()?.toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).replace(/,/, '')}</span></p>
                  <p><span class="label">Valid Till:</span> <span class="value">${responseV.data.extendedValidTill?.toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).replace(/,/, '')}</span></p>
                  <p><span class="label">Assets:</span> <span class="value">${responseV.data.visitorAssets || ''}</span></p>
                  <p><span class="label">Remarks:</span></p>
                  <p><span class="label">Card No:</span> <span class="value">${responseV.data.cardNumber || ''}</span></p>

                </div>

                <!-- Footer with QR Code and Signatures -->
                <div class="footer">
                  <div style="display:flex;flex-direction:column;text-align:left;">
                    <div style="margin-bottom:30px;text-align:left">Visitor Sign</div>
                    <div>Employee Sign</div>
                  </div>
                  <div class="qr-code">
                    <img src="${qrCodeDataUrl}" alt="QR Code" />
                  </div>
                </div>
              </div>
            </body>
          </html>
    `);
            doc.close();

            // Use onload event to ensure the content and styles are fully loaded before printing
            iframe.onload = () => {
              setTimeout(() => {
                iframe.contentWindow.print();
                document.body.removeChild(iframe); // Remove the iframe after printing
              }, 500);
              // Slight delay for style rendering
            };
          };
        }
      } else {
        setError('No data received or missing required fields.');
      }

    } catch (error) {
      console.error('Error fetching appointment details:', error);
      // Handle error scenarios
    }

    // Reset the form fields
    setMobileNumber('');
  };
  function encryptMobileNumber(mobile) {
    let encryptedNumber = '';

    // Iterate over each digit of the mobile number
    for (let i = 0; i < mobile.length; i++) {
      // Convert the digit to its ASCII code and pad it to two digits
      const asciiCode = mobile[i].charCodeAt(0).toString().padStart(2, '0');
      encryptedNumber += asciiCode; // Concatenate to the encrypted string
    }

    return encryptedNumber;
  }
  const qrCodeRef = useRef();
  // Create a ref to access the QR code canvas

  const printQRCode = async () => {
    // Create a new iframe element
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    // Convert QR code to data URL
    const qrCodeDataUrl = qrCodeRef.current.toDataURL();

    // Fetch the SVG image and convert to base64
    const response = await fetch(centerImage);
    const blob = await response.blob();
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64Svg = reader.result;

      // Write the content into the iframe
      const doc = iframe.contentWindow.document;
      doc.open();

      doc.write(`
     <html>
  <head>
    <title>Print QR Code</title>
    <style>
      @page { 
        margin: 0; 
      }
      body {
        font-family: Arial, sans-serif;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        margin: 0;
      }
      .container {
        width: 250px;
        border: 1px solid #000;
        padding: 10px;
        text-align: center;
      }
      .header img {
        width: 100px;
        height: auto;
        margin-bottom: 10px;
      }
      .imageN img {
        width: 100px !important;
        height: 100px !important;
        margin-bottom: 10px;
      }
      .visitor-details {
        text-align: left;
        font-size: 14px;
        margin-top: 10px;
      }
      .visitor-details p {
        margin: 4px 0;
        display: flex;
      }
      .label {
        font-weight: 400;
        width: 80px; /* Adjust width as needed to align labels and values */
      }
      .value {
        flex-grow: 1;
      }
      .footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        padding-top: 10px;
      }
      .footer div {
        text-align: center;
        font-weight: 600;
        font-size: 12px;
      }
      .qr-code img {
        width: 80px;
        height: 80px;
      }
      /* Hide print and close buttons in print view */
      @media print {
        .no-print { 
          display: none; 
        }
      }
    </style>
  </head>
  <body>
    <div class="container">
      <!-- Company Logo -->
      <div class="header">
        <img src="${centerImage}" alt="Infosys Logo" />
      </div>
      
      <!-- Visitor Photo -->
      <div class="imageN">
        <img src="${profileImage}" alt="Visitor Photo" />
      </div>

      <!-- Visitor Details -->
      <div class="visitor-details">
        <p><span class="label">PassId:</span> <span class="value">${cardData?.id || cardData?.checkInId}</span></p>
        <p><span class="label">Name:</span> <span class="value">${cardData?.visitorName || cardData?.groupLeaderName}</span></p>
        <p><span class="label">Org:</span> <span class="value">${cardData?.visitorCompany}</span></p>
        <p><span class="label">Purpose:</span> <span class="value">${cardData.purpose || ""}</span></p>
        <p><span class="label">Buildings:</span> <span class="value">${cardData.building || cardData.buildings || ''}</span></p>
        <p><span class="label">Gates:</span> <span class="value">${cardData.gate || cardData.gates || ''}</span></p>
        <p><span class="label">IN-Time:</span> <span class="value">${new Date().toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).replace(/,/, '')}</span></p>
        <p><span class="label">Valid Till:</span> <span class="value">${cardData.extendedValidTill?.toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).replace(/,/, '') || ''}</span></p>
        <p><span class="label">Assets:</span> <span class="value">${cardData.visitorAssets || ""}</span></p>
        <p><span class="label">Remarks:</span></p>
      </div>

      <!-- Footer with QR Code and Signatures -->
      <div class="footer">
        <div style="display:flex;flex-direction:column;text-align:left;">
          <div style="margin-bottom:30px;text-align:left">Visitor Sign</div>
          <div>Employee Sign</div>
        </div>
        <div class="qr-code">
          <img src="${qrCodeDataUrl}" alt="QR Code" />
        </div>
      </div>
    </div>
  </body>
</html>

         
     `);


      doc.close();

      // Use onload event to ensure the content and styles are fully loaded before printing
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.print();
          document.body.removeChild(iframe); // Remove the iframe after printing
        }, 500);
        // Slight delay for style rendering
      };
    };
  };
  const handleSubmitSingleW = async (e) => {
    setError('');

    // Validate the mobile number
    if (mobileNumber.length !== 10) {
      setError('Mobile number must be exactly 10 digits.');
      return;
    }

    // Validate if the checkbox is checked
    // if () {
    //   setError('Please check the Baggage Tag checkbox.');
    //   return;
    // }

    // If validation passes, log the mobile number
    console.log('Mobile Number:', mobileNumber);

    try {

      const response = await axios.get(`/VisitorDetails/VisitorDetails/${mobileNumber}`);
      console.log("response", response);

      if (response.data && response.data?.visitorName) {
        setCardData(response.data);
        setProfileImage(`data:image/png;base64,${response.data?.visitorPhoto}`);
        const formattedData = `${encryptMobileNumber(mobileNumber)}`;
        setQrCodeValue(formattedData);
        if (baggageTag) {
          setShowQRCode(true);
        }
        if (!baggageTag) {
          setShowQRCode(true);
          const responseV = await axios.get(`/VisitorDetails/VisitorDetails/${mobileNumber}`);
          console.log("response", responseV);
          setProfileImage(`data:image/png;base64,${responseV.data?.visitorPhoto}`);

          // Create a new iframe element
          const iframe = document.createElement('iframe');
          iframe.style.position = 'absolute';
          iframe.style.width = '0';
          iframe.style.height = '0';
          iframe.style.border = 'none';
          document.body.appendChild(iframe);

          // Convert QR code to data URL
          const qrCodeDataUrl = qrCodeRef.current.toDataURL();

          // Fetch the SVG image and convert to base64
          const response = await fetch(centerImage);
          const blob = await response.blob();
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64Svg = reader.result;

            // Write the content into the iframe
            const doc = iframe.contentWindow.document;
            doc.open();

            doc.write(`
          <html>
            <head>
              <title>Print QR Code</title>
              <style>
                 @page { 
    margin: 0; 
  }
  body {
    font-family: Segoe UI;
    margin: 2;
    padding: 2;
  }
                      .container {
              width: 7cm;
              height: 10cm;
              border: 1px solid #000;
              padding: 5px;
              text-align: center;
              box-sizing: border-box;
            }
            .header img {
              width: 90px;
              height: auto;
              margin-bottom: 6px;
            }
            .imageN img {
              width: 100px;
              height: 60px;
              margin-bottom: 6px;
            }
            .visitor-details {
              text-align: left;
              font-size: 10px;
              margin-top: 6px;
            }
            .visitor-details p {
              margin: 2px 0;
              display: flex;
            }
            .label {
              font-weight: 400;
              width: 70px;
            }
            .value {
              flex-grow: 1;
            }
            .footer {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 8px;
              padding-top: 6px;
            }
            .footer div {
              text-align: center;
              font-weight: 600;
              font-size: 9px;
            }
            .qr-code img {
              width: 60px;
              height: 60px;
            }
            @media print {
              .no-print {
                display: none;
              }
                }
              </style>
            </head>
            <body>
              <div class="container">
                <!-- Company Logo -->
                <div class="header">
                  <img src="${centerImage}" alt="Infosys Logo" />
                </div>
                
                
                <!-- Visitor Photo -->
                <div class="imageN">
                  <img src="${`data:image/png;base64,${responseV.data.visitorPhoto}`}" alt="Visitor Photo" />
                </div>

                <!-- Visitor Details -->
                <div class="visitor-details">
                  <p><span class="label">PassId:</span> <span class="value">${responseV.data?.checkInId || ''}</span></p>
                  <p><span class="label">Name:</span> <span class="value">${responseV.data?.visitorName || cardData?.visitorName}</span></p>
                  <p><span class="label">Org:</span> <span class="value">${responseV.data?.visitorCompany || ''}</span></p>
                  <p><span class="label">Purpose:</span> <span class="value">${responseV.data.purpose}</span></p>
                  <p><span class="label">Buildings:</span> <span class="value">${responseV.data.building || ''}</span></p>
                  <p><span class="label">Gates:</span> <span class="value">${responseV.data.gate || ""}</span></p>
                  <p><span class="label">IN-Time:</span> <span class="value">${new Date()?.toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).replace(/,/, '')}</span></p>
                  <p><span class="label">Assets:</span><span class="value">${responseV.data.visitorAssets || ""}</span></p>
                  <p><span class="label">Remarks:</span></p>
                </div>

                <!-- Footer with QR Code and Signatures -->
                <div class="footer">
                  <div style="display:flex;flex-direction:column;text-align:left;">
                    <div style="margin-bottom:30px;text-align:left">Visitor Sign</div>
                    <div>Employee Sign</div>
                  </div>
                  <div class="qr-code">
                    <img src="${qrCodeDataUrl}" alt="QR Code" />
                  </div>
                </div>
              </div>
            </body>
          </html>
    `);
            doc.close();

            // Use onload event to ensure the content and styles are fully loaded before printing
            iframe.onload = () => {
              setTimeout(() => {
                iframe.contentWindow.print();
                document.body.removeChild(iframe); // Remove the iframe after printing
              }, 500);
              // Slight delay for style rendering
            };
          };
        }
      } else {
        setError('No data received or missing required fields.');
      }

    } catch (error) {
      console.error('Error fetching appointment details:', error);
      // Handle error scenarios
    }

    // Reset the form fields
    setMobileNumber('');
  };

  const generateQRCodeDataUrl = (data) => {
    return new Promise((resolve, reject) => {
      QRCode.toDataURL(data, { width: 256, margin: 1 }, (err, url) => {
        if (err) {
          console.error('Error generating QR Code:', err);
          reject(err);
        } else {
          resolve(url); // Return the data URL
        }
      });
    });
  };
  function encodeCheckInId(checkInId) {
    if (checkInId === undefined || checkInId === null) {
      throw new Error("Invalid checkInId: it must be a valid number.");
    }

    // Mapping digits to specific encoded pairs
    const digitMapping = {
      1: "515253",
      3: "303030",
      5: "505050",
      2: "202020",
      4: "868484",
      6: "606060",
      7: "707070",
      8: "808080",
      9: "909090",
      0: "000000"
    };

    // Convert the Check-In ID to a string and map each digit to its corresponding encoding
    const checkInIdStr = checkInId.toString();

    // Ensure all digits are mapped to encoded values
    const encoded = checkInIdStr
      .split('')  // Split into individual digits
      .map(digit => {
        const mappedValue = digitMapping[parseInt(digit)];
        if (!mappedValue) {
          throw new Error(`No mapping found for digit: ${digit}`);
        }
        return mappedValue;  // Map digits to encoded values
      })
      .join(''); // Join all the parts to form the final encoded string

    return encoded;
  }

  // const ReprintVisitorPass = async (Details) => {
  //   console.log("Details", Details);
  //   setError('');
  //   const formattedMobileNumber = `${defaultNationalityCode}-${mobileNumber}`;

  //   const response = await axios.get(`/VisitorDetails/ReprintPass/${formattedMobileNumber}`);

  //   Details = response.data.reprintPassDetails

  //       const responseTemplate = await axios.get('User/GetTemplate');

  //       console.log("responseTemplate",responseTemplate.data);




  //   // Ensure Details is an array, even if it's a single object
  //   const detailsArray = Array.isArray(Details) ? Details : [Details];

  //   for (const detail of detailsArray) {
  //     // Create a new iframe element
  //     const iframe = document.createElement('iframe');
  //     iframe.style.position = 'absolute';
  //     iframe.style.width = '0';
  //     iframe.style.height = '0';
  //     iframe.style.border = 'none';
  //     document.body.appendChild(iframe);
  //     const encodedId = encodeCheckInId(detail.checkInId);
  //     console.log(encodedId);

  //     const formattedData = `${encodedId}`;
  //     console.log("formattedData", formattedData);


  //     const qrCodeDataUrlV = await generateQRCodeDataUrl(formattedData);
  //     console.log("qrCodeDataUrlV", qrCodeDataUrlV);

  //     if (!qrCodeDataUrlV) {
  //       console.error('QR Code data URL not generated.');
  //       return;
  //     }

  //     // Convert QR code to data URL

  //     // Fetch the SVG image and convert to base64
  //     const response = await fetch(centerImage || userImage);
  //     const blob = await response.blob();
  //     const reader = new FileReader();
  //     reader.readAsDataURL(blob);
  //     reader.onloadend = () => {
  //       const base64Svg = reader.result;
  //       const templateStyle = responseTemplate.data == 1
  //       ? `
  //       <style>
  //         @page { margin: 0; }
  //         body {
  //           font-family: Arial, sans-serif;
  //           display: flex;
  //           align-items: center;
  //           justify-content: center;
  //           padding: 20px;
  //           margin: 0;
  //         }
  //         .container {
  //           width: 250px;
  //           border: 1px solid #000;
  //           padding: 10px;
  //           text-align: center;
  //         }
  //         .header img {
  //           width: 100px;
  //           height: auto;
  //           margin-bottom: 10px;
  //         }
  //         .imageN img {
  //           width: 100px;
  //           height: 100px;
  //           margin-bottom: 10px;
  //         }
  //         .visitor-details {
  //           text-align: left;
  //           font-size: 14px;
  //           margin-top: 10px;
  //         }
  //         .visitor-details p {
  //           margin: 4px 0;
  //           display: flex;
  //         }
  //         .label {
  //           font-weight: 400;
  //           width: 80px;
  //         }
  //         .value {
  //           flex-grow: 1;
  //         }
  //         .footer {
  //           display: flex;
  //           justify-content: space-between;
  //           align-items: center;
  //           margin-top: 10px;
  //           padding-top: 10px;
  //         }
  //         .footer div {
  //           text-align: center;
  //           font-weight: 600;
  //           font-size: 12px;
  //         }
  //         .qr-code img {
  //           width: 80px;
  //           height: 80px;
  //         }
  //         @media print {
  //           .no-print {
  //             display: none;
  //           }
  //         }
  //       </style>
  //       `
  //       : `
  //       <style>
  //         @page { margin: 0; }
  //         body {
  //           font-family: Segoe UI;
  //           margin: 10;
  //           padding: 10;
  //         }
  //         .container {
  //           width: 7cm;
  //           height: 10cm;
  //           border: 1px solid #000;
  //           padding: 5px;
  //           text-align: center;
  //           box-sizing: border-box;
  //         }
  //         .header img {
  //           width: 90px;
  //           height: auto;
  //           margin-bottom: 6px;
  //         }
  //         .imageN img {
  //           width: 100px;
  //           height: 60px !important;
  //           margin-bottom: 6px;
  //         }
  //         .visitor-details {
  //           text-align: left;
  //           font-size: 10px;
  //           margin-top: 6px;
  //         }
  //         .visitor-details p {
  //           margin: 2px 0;
  //           display: flex;
  //         }
  //         .label {
  //           font-weight: 400;
  //           width: 70px;
  //         }
  //         .value {
  //           flex-grow: 1;
  //         }
  //         .footer {
  //           display: flex;
  //           justify-content: space-between;
  //           align-items: center;
  //           margin-top: 8px;
  //           padding-top: 6px;
  //         }
  //         .footer div {
  //           text-align: center;
  //           font-weight: 600;
  //           font-size: 9px;
  //         }
  //         .qr-code img {
  //           width: 60px;
  //           height: 60px;
  //         }
  //         @media print {
  //           .no-print {
  //             display: none;
  //           }
  //         }
  //       </style>
  //       `;


  //       // Write the content into the iframe
  //       const doc = iframe.contentWindow.document;
  //       doc.open();

  //       doc.write(`
  //         <html>
  //           <head>
  //             <title>Print QR Code</title>
  //               ${templateStyle}
  //           </head>
  //           <body>
  //             <div class="container">
  //               <!-- Company Logo -->
  //               <div class="header">
  //                 <img src="${centerImage}" alt="Company Logo" />
  //               </div>

  //               <!-- Visitor Photo -->
  //               <div class="imageN">
  //                 <img src="${detail.visitorPhoto ? `data:image/png;base64,${detail.visitorPhoto}` : userImage}" alt="Visitor Photo" />
  //               </div>

  //               <!-- Visitor Details -->
  //               <div class="visitor-details">
  //                 <p><span class="label">PassId:</span> <span class="value">${detail.checkInId || ''}</span></p>
  //                 <p><span class="label">Name</span> <span class="value">${detail.visitorName || detail?.visitorName}</span></p>
  //                 <p><span class="label">Org:</span> <span class="value">${detail.visitorCompany || ''}</span></p>
  //                 <p><span class="label">Purpose:</span> <span class="value">${detail.purpose}</span></p>
  //                 <p><span class="label">Buildings:</span> <span class="value">${detail.buildingName || detail.buildings || ''}</span></p>
  //                 <p><span class="label">Gates:</span> <span class="value">${detail.gateName || detail.gates || ""}</span></p>
  //                 <p><span class="label">IN-Time:</span> <span class="value">${detail.checkInDateTime}</span></p>
  //                 <p><span class="label">ValidTill:</span> <span class="value">${detail.extendedValidTill}</span></p>
  //                 <p><span class="label">Assets:</span><span class="value">${detail.visitorAssets || ""}</span></p>
  //                 <p><span class="label">Remarks:</span> <span class="value">${detail.remarks || ''}</span></p>
  //                 <p><span class="label">Card No:</span> <span class="value">${detail.cardNumber || ''}</span></p>
  //               </div>

  //               <!-- Footer with QR Code and Signatures -->
  //               <div class="footer">
  //                 <div style="display:flex;flex-direction:column;text-align:left;">
  //                   <div style="margin-bottom:30px;text-align:left">Visitor Sign</div>
  //                   <div>Employee Sign</div>
  //                 </div>
  //                 <div class="qr-code">
  //                   <img src="${qrCodeDataUrlV}" alt="QR Code" />
  //                 </div>
  //               </div>
  //             </div>
  //           </body>
  //         </html>
  //       `);
  //       doc.close();

  //       // Use onload event to ensure the content and styles are fully loaded before printing
  //       iframe.onload = () => {
  //         setTimeout(() => {
  //           iframe.contentWindow.print();
  //           document.body.removeChild(iframe); // Remove the iframe after printing
  //         }, 500);
  //       };
  //     };
  //   }

  //   // Reset the form fields
  //   setMobileNumber('');
  // };
  const ReprintVisitorPass = async (Details) => {
    console.log("Details", Details);
    setError('');
    const formattedMobileNumber = `${defaultNationalityCode}-${mobileNumber}`;

    try {
      const response = await axios.get(`/VisitorDetails/ReprintPass/${formattedMobileNumber}`);
      Details = response.data.reprintPassDetails;

      // Ensure Details is always an array
      const detailsArray = Array.isArray(Details) ? Details : [Details];

      for (const detail of detailsArray) {
        if (!detail.badgeFront && !detail.badgeBack) {
          toast.warning("No visitor pass available.");
          return;
        }


        // Create hidden iframe
        const iframe = document.createElement("iframe");
        iframe.style.position = "absolute";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "none";
        document.body.appendChild(iframe);

        const doc = iframe.contentWindow.document;
        doc.open();

        // Combine badgeFront + badgeBack into a single printable page
        doc.write(`
  <html>
    <head>
      <title>Visitor Pass</title>
      <style>
        @page { margin: 0; }
        body { 
          margin: 0; 
          display: flex; 
          justify-content: space-around;
          align-items: flex-start;
          padding: 5px;
        }
        .badge {
          margin: 10px;
          width: 8cm;      /* keep width fixed */
          height: 49cm;    /* increased height */
          box-sizing: border-box;
        }
        @media print {
          .no-print { display: none; }
        }
      </style>
    </head>
    <body>
      <div class="badge">
        ${detail.badgeFront || ""}
      </div>
      <div class="badge">
        ${detail.badgeBack || ""}
      </div>
    </body>
  </html>
`);

        doc.close();

        // Trigger print once iframe is ready
        iframe.onload = () => {
          setTimeout(() => {
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
          }, 500);
        };
      }

      // Reset form fields
      setMobileNumber('');
    } catch (error) {
      console.error("Error in ReprintVisitorPass:", error);
      setError("Failed to fetch or print visitor pass.");
    }
  };
  const closeQRCodePopup = async () => {
    const formattedMobileNumber = `${defaultNationalityCode}-${mobileNumber}`;
    const response = await axios.get(`/VisitorDetails/ReprintPass/${formattedMobileNumber}`);

    ReprintVisitorPass(response.data.reprintPassDetails)
    setBaggageTag(false);
    setShowQRCode(false);
  };
  const printQRCodeV = async () => {
    // Create a new iframe element
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    // Convert QR code to data URL
    const qrCodeDataUrl = qrCodeRef.current.toDataURL();

    // Fetch the SVG image and convert to base64
    const response = await fetch(centerImage);
    const blob = await response.blob();
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64Svg = reader.result;

      // Write the content into the iframe
      const doc = iframe.contentWindow.document;
      doc.open();

      doc.write(`
        <html>
          <head>
            <title>Print QR Code</title>
            <style>
              /* Reset default print margins */
              @page { margin: 0; }
              body {
                font-family: Arial, sans-serif;
                margin: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
              }
              h2 {
                font-size: 1.5em;
                margin: 10px 0;
              }
              .visitor-label, .baggage-label {
                display: inline-block;
                background-color: #FF7A00;
                padding: 5px;
                width:300px;
                color: #FFF;
                font-weight: bold;
                font-size: 1.2em;
                margin: 10px 0;
                text-align: center;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              p {
                font-size: 0.8em;
                color: #888;
              }
              img {
                max-width: 100%;
                margin: 10px 0;
              }
            </style>
          </head>
          <body>
            <!-- SVG Image Above Header -->
            <div style="text-align: center; margin-bottom: 10px;">
              <img src="${centerImage}" alt="Infosys Logo" style="width: 170px; height: 100px;" />
            </div>
  
            <h2>${cardData?.visitorName || cardData?.groupLeaderName || reprintData[0]?.visitorName}</h2>
            <div class="visitor-label">VISITOR</div>
            <img src="${qrCodeDataUrl}" alt="QR Code" />
            <div class="baggage-label">BAGGAGE TAG</div>
            <p>Visitor Management System</p>
          </body>
        </html>
      `);
      doc.close();

      // Use onload event to ensure the content and styles are fully loaded before printing
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.print();
          document.body.removeChild(iframe); // Remove the iframe after printing
        }, 500);
        // Slight delay for style rendering
      };
    };
  };

  return (
    <Container>
      <Header>
        <PageHeader>Reprint Pass</PageHeader>
      </Header>
      <CardContainer>
        <Card>
          <CardHeader>Enter Mobile Number</CardHeader>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <ISDSelect onChange={handleIsdChange} value={defaultNationalityCode}>
                {Array.isArray(nationalityList) && nationalityList.length > 0 ? (
                  <>
                    <option value="" disabled>
                      Select Nationality
                    </option>
                    {nationalityList.map((nation) => (
                      <option
                        key={nation.id}
                        value={nation.nationalityCode}
                        disabled={nation.isBlackListed}
                      >
                        {`${nation.name} (${nation.nationalityCode})`}
                      </option>
                    ))}
                  </>
                ) : (
                  <option value="" disabled>Loading...</option>
                )}
              </ISDSelect>
              <Input
                type="tel"
                id="mobileNumber"
                name="mobileNumber"
                placeholder="Enter  Mobile Number"
                maxLength={defaultNationalityCode === "91" ? 10 : 15}
                value={mobileNumber}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                  setMobileNumber(onlyNumbers);
                }}
                required
              />
              {error && <ErrorMessage>{error}</ErrorMessage>}
            </FormGroup>
            <CheckboxContainer>
              <input
                type="checkbox"
                id="baggageTag"
                name="baggageTag"
                checked={baggageTag}
                onChange={() => setBaggageTag(!baggageTag)}
              />
              <CheckboxLabel htmlFor="baggageTag">Baggage Tag</CheckboxLabel>
            </CheckboxContainer>
            <SubmitButton type="submit">Submit</SubmitButton>
          </Form>
        </Card>
      </CardContainer>
      {showQRCode && baggageTag && (
        <PopupContainer onClick={closeQRCodePopup}>
          <PopupContent className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
              <img src={centerImage} alt="Infosys Logo" style={{ width: '170px', height: '100px' }} />
            </div>
            <h2 style={{ fontSize: '1.5em', margin: '10px 0' }}>{reprintData[0]?.visitorName}</h2>

            <div style={{ backgroundColor: '#FF7A00', padding: '5px', color: '#FFF', fontWeight: 'bold', fontSize: '1.2em', margin: '10px 0' }}>
              VISITOR
            </div>

            {/* QR Code with Visitor Data */}
            <QRCodeCanvas ref={qrCodeRef} value={qrCodeValue} size={256} />
            {baggageTag && (
              <div style={{ backgroundColor: '#FF7A00', padding: '5px', color: '#FFF', fontWeight: 'bold', fontSize: '1em', margin: '10px 0' }}>
                BAGGAGE TAG
              </div>
            )}


            <p style={{ fontSize: '0.8em', color: '#888' }}>Visitor Management System</p>
            <ButtonContainer>
              <PopupButton onClick={printQRCodeV}>Print</PopupButton>
              <PopupButton className="no-button" onClick={closeQRCodePopup}>Close</PopupButton>
            </ButtonContainer>

          </PopupContent>

        </PopupContainer>
      )}
      {!baggageTag &&
        <QRCodeCanvas ref={qrCodeRef} value={qrCodeValue} size={256} style={{ display: 'none' }} />

      }
      <ToastContainer />
    </Container>
  );
};

export default ReprintPassPage;
